import { render, staticRenderFns } from "./tabelaPerguntas.vue?vue&type=template&id=226b2a43&scoped=true"
import script from "./tabelaPerguntas.vue?vue&type=script&lang=js"
export * from "./tabelaPerguntas.vue?vue&type=script&lang=js"
import style0 from "./tabelaPerguntas.vue?vue&type=style&index=0&id=226b2a43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b2a43",
  null
  
)

export default component.exports